import React from 'react';
import WeekCard from './WeekCard';
import { applyFlkFilter } from './plannerUtils';

// ─── DayColumn — week view ────────────────────────────────────────────────────

const WEEK_COL_MAX = 4;

function DayColumn({ dateStr, dayData, allWeekDates, onComplete, onMove, onAddEntry, isToday, isPast, flkFilter, toggles, onSwitchToDayView }) {
  const rawEntries = dayData.entries || [];
  const entries = applyFlkFilter(rawEntries, flkFilter);
  const { is_study_day } = dayData;
  const completed_count = entries.filter(e => e.status === 'completed').length;
  const total_count = entries.length;

  const d = new Date(dateStr + 'T00:00:00');
  const dayLabel = d.toLocaleDateString('en-GB', { weekday: 'short' });
  const dateLabel = d.getDate();
  const visibleEntries = entries.slice(0, WEEK_COL_MAX);
  const hiddenCount = entries.length - WEEK_COL_MAX;

  return (
    <div className={`week-col${isToday ? ' week-col-today' : ''}`}>
      <div className="week-col-head">{dayLabel} {dateLabel}</div>
      {is_study_day && total_count > 0 && (
        <div className="week-col-count">{completed_count} of {total_count}</div>
      )}
      {!is_study_day ? (
        <div style={{ fontSize: '11px', color: 'var(--text-tertiary)', padding: '4px 0' }}>Rest day</div>
      ) : (
        <>
          <div className="week-cards">
            {visibleEntries.map(entry => (
              <WeekCard
                key={entry.id}
                entry={entry}
                dateStr={dateStr}
                toggles={toggles}
                onSwitchToDayView={onSwitchToDayView}
              />
            ))}
          </div>
          {hiddenCount > 0 && (
            <div className="week-more" onClick={() => onSwitchToDayView && onSwitchToDayView(dateStr)}>
              +{hiddenCount} more
            </div>
          )}
          {/* +Add button only in day view — hidden in week view */}
        </>
      )}
    </div>
  );
}

// ─── WeekView ────────────────────────────────────────────────────────────────

export default function WeekView({ weekData, weekDates, today, flkFilter, toggles, onComplete, onMove, onAddEntry, onSwitchToDayView, weekGridRef, weekScrollLeft, weekScrollRight, onScrollWeekGrid }) {
  return (
    <>
      {weekData?.is_projected && (
        <div className="week-projected">Projected — will adjust as you add data</div>
      )}
      <div className="week-grid-wrapper">
        {weekScrollLeft && (
          <button className="week-scroll-btn week-scroll-btn--left" onClick={() => onScrollWeekGrid(-1)}>‹</button>
        )}
        {weekScrollRight && (
          <button className="week-scroll-btn week-scroll-btn--right" onClick={() => onScrollWeekGrid(1)}>›</button>
        )}
        <div className="week-grid" ref={weekGridRef} style={{ overflowX: 'auto' }}>
          {weekDates.map(dateStr => {
            const dayData = weekData.days[dateStr];
            if (!dayData) return null;
            return (
              <DayColumn
                key={dateStr}
                dateStr={dateStr}
                dayData={dayData}
                allWeekDates={weekDates}
                onComplete={onComplete}
                onMove={onMove}
                onAddEntry={onAddEntry}
                isToday={dateStr === today}
                isPast={dateStr < today}
                flkFilter={flkFilter}
                toggles={toggles}
                onSwitchToDayView={onSwitchToDayView}
              />
            );
          })}
        </div>
      </div>
    </>
  );
}
